<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="subtitle-1">
        <v-row>
          <v-col sm="12" md="8">
            <template v-if="orderrItemGroup.set != null">
              {{ orderrItemGroup.set.title }}
            </template>
            <template v-else>
              {{ orderrItemGroup.product.title }}
            </template>
          </v-col>
          <v-col sm="12" md="4">
            <template v-if="mobConfig.showPriceWithoutDPH"
              >{{ orderrItemGroup.priceWithoutDph / 100 }}
            </template>
            <template v-else>{{ orderrItemGroup.price / 100 }} </template>
            {{ $t(mobConfig.currency) }}</v-col
          >
        </v-row>
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ orderrItemGroup.length }} {{ $t(orderrItemGroup.priceListType) }}:
        {{ dateStartFormated }} -
        {{ dateEndFormated }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        <subject-profile-compact
          v-bind:subject-profile="orderrItemGroup.subjectProfile"
        ></subject-profile-compact>
      </v-list-item-subtitle>

      <ul>
        <li v-for="oi in orderrItemGroup.orderrItems.items" v-bind:key="oi.id">
          <template v-if="orderrItemGroup.set != null">
            {{ oi.product.title }}:
          </template>
          <span v-if="oi.article">
            {{ oi.article.title }}, {{ oi.article.size }}
            {{ oi.article.sizeUnit }}
          </span>
        </li>
      </ul>
    </v-list-item-content>
    <v-list-item-action v-if="!removeBtnDisabled">
      <v-btn icon @click="deleteItem" :disabled="currentOrderrExpired">
        <v-icon color="grey lighten-1">mdi-close</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import SubjectProfileCompact from "@/components/SubjectProfileCompact";
import moment from "moment";

export default {
  name: "CartItemRent",

  components: {
    SubjectProfileCompact,
  },

  props: {
    orderrItemGroup: {
      type: Object,
      required: true,
    },
    removeBtnDisabled: {
      type: Boolean,
      value: false,
    },
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    dateStartFormated() {
      return moment(this.orderrItemGroup.dateStart).format("D. M. YYYY");
    },

    dateEndFormated() {
      return moment(this.orderrItemGroup.dateEnd).format("D. M. YYYY");
    },
    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },
  },

  methods: {
    deleteItem() {
      this.$store.dispatch("removeFromCart", this.orderrItemGroup);
    },
  },
};
</script>
